import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import VueTextareaAutosize from 'vue-textarea-autosize'
import axios from 'axios';
import firebase from "firebase";
import router from './router'
import store from './store'


Vue.use(VueTextareaAutosize)
Vue.use(axios)

firebase.initializeApp({
		apiKey: "AIzaSyBwA94_UEjREzcA7sfWuhWl81vgpYMru5A",
		authDomain: "vue-calendar-all-bbbc9.firebaseapp.com",
		databaseURL: "https://vue-calendar-all-bbbc9.firebaseio.com",
		projectId: "vue-calendar-all-bbbc9",
		storageBucket: "vue-calendar-all-bbbc9.appspot.com",
		messagingSenderId: "658870236398",
		appId: "1:658870236398:web:52ee81d26ac6625f0f6fff",
	});
export const db = firebase.firestore();

Vue.config.productionTip = false
// axios.defaults.baseURL ='https://backend.kingvape.cr/'
// axios.defaults.baseURL ='http://rest.noah.cr/Backend' //BackendRest
// axios.defaults.baseURL ='https://localhost:44388/'
// axios.defaults.baseURL ='https://crifasa.pdvcostarica.com/'
 //axios.defaults.baseURL ='https://backend.pdvcostarica.com/'//
 axios.defaults.baseURL ='https://backendrest.pdvcostarica.com/'//
 //axios.defaults.baseURL ='/Backend'

  new Vue({
    vuetify,
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
  


